// Vendors
import { useTranslation } from 'react-i18next';

const Trans = ({ file, id, fallback, args }) => {
  const { t } = useTranslation(file);
  const fallbackText = fallback || id;
  
  return <>{t(id, args || fallbackText)}</>;
};

export default Trans;
